'use strict';

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require("jquery");

var Resx = (0, _localize2.default)('Common', 'App', 'Messages');

var cmsPageService = abp.services.api.cmsPage;
var currentOrdering = null;

function initNestable() {
    $('.cmsPageSectionsNestable').nestable({
        dragClass: 'dd-dragel nestable',
        maxDepth: 1
    }).on('change', function (e) {
        var ordering = $('.cmsPageSectionsNestable').nestable('serialize');

        // since this event may be fired multiple times during a single update, we should check whether the update is really necessary
        var saveOrdering = false;

        if (currentOrdering != null) {
            if (currentOrdering.length != ordering.length) {
                saveOrdering = true;
            } else {
                for (var i = 0; i < ordering.length; i++) {
                    if (ordering[i].id != currentOrdering[i].id) {
                        saveOrdering = true;
                        break;
                    }
                }
            }
        } else {
            saveOrdering = true;
        }

        if (saveOrdering) {
            currentOrdering = ordering;
            var cmsPageId = $('#Id').val();
            cmsPageService.updateOrder(cmsPageId, ordering.map(function (i) {
                return i.id;
            })).done(function () {
                _notify2.default.success(Resx.Common.SettingsSaved);
            }).fail(function () {
                _notify2.default.error(Resx.Common.AjaxError);
            });
        }
    });
}

function setupButtonEvents() {
    $("a[cms-page-section-item-button-delete]").on("click", function (e) {
        e.preventDefault();
        var $buttonClicked = $(this);
        _message2.default.confirm(Resx.App.CmsPageSectionDeleteConfirmation, Resx.Messages.ConfirmTitle, function (isConfirmed) {
            if (isConfirmed) {
                var deleteUrl = $buttonClicked.attr("data-url");
                var elementToUpdate = '#' + $buttonClicked.attr("data-update-target");
                $.post(deleteUrl, function (data) {
                    $(elementToUpdate).html(data);
                    _notify2.default.success(Resx.App.CmsPageSectionDeleteConfirmed);
                    cmsPageSectionOnLoad();
                }).fail(function () {
                    _notify2.default.error(Resx.Common.AjaxError);
                });
            }
        });
    });
}

function cmsPageSectionOnLoad() {
    initNestable();
    setupButtonEvents();
}

module.exports = exports.default = function () {
    cmsPageSectionOnLoad();

    window.linksoft.setupCmsSections = function () {
        cmsPageSectionOnLoad();
    };
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cmsPageSections.js
// module id = 419
// module chunks = 0